import { Sparkles, Check } from "lucide-react";

const bullets = [
  "Mengandung antioksidan alami",
  "Rasa segar dan ringan",
  "Cocok untuk konsumsi harian",
];

const EducationSection = () => (
  <section
    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16"
    data-testid="edu-section"
  >
    <div className="bg-white border border-stone-200 rounded-2xl p-6 sm:p-8 shadow-sm grid md:grid-cols-5 gap-6 md:gap-8 items-center">
      <div className="md:col-span-3">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-50 text-purple-700 text-sm font-medium border border-purple-100">
          <Sparkles className="w-4 h-4" /> Edukasi singkat
        </span>
        <h2 className="mt-3 font-display text-2xl sm:text-3xl font-semibold text-stone-900">
          Kenapa Memilih Minuman Herbal?
        </h2>
        <p className="mt-3 text-stone-600 text-base sm:text-lg leading-relaxed">
          Minuman herbal seperti telang dan rosella dikenal sebagai pilihan
          alami untuk menemani gaya hidup sehat. Kandungan alaminya dapat
          membantu mendukung keseimbangan tubuh jika dikonsumsi secara rutin
          dan wajar.
        </p>
      </div>
      <ul className="md:col-span-2 space-y-2.5">
        {bullets.map((b) => (
          <li
            key={b}
            className="flex items-start gap-3 bg-stone-50 border border-stone-100 rounded-xl px-4 py-3"
          >
            <span className="inline-flex w-6 h-6 rounded-full bg-emerald-100 text-emerald-700 items-center justify-center shrink-0 mt-0.5">
              <Check className="w-3.5 h-3.5" />
            </span>
            <span className="text-stone-800 font-medium">{b}</span>
          </li>
        ))}
        <p className="text-xs text-stone-500 pl-1">
          Hasil dapat berbeda pada setiap individu.
        </p>
      </ul>
    </div>
  </section>
);

export default EducationSection;
